import React, { useState, useEffect } from 'react';
import { fetchUsersList } from '../../api/auth';
import SearchDropdown from './searchDropdown';
import { fetchUserRolesData } from '../../api/admin';
interface Props {
  selectedUserRole: any;
  setSelectedUserRole: any;
}
const SelectUserRoleDropdown = ({
  selectedUserRole,
  setSelectedUserRole,
}: Props) => {
  const [userRolesList, setUserRolesList] = useState<any>();

  useEffect(() => {
    fetchUserRolesData({ is_pagination: false })
      .then((response) => {
        if (!response?.data?.is_error) {
          let usersData = response?.data?.content;
          const formattedUsersList: any = usersData.map((item: any) => ({
            label: item?.name,
            value: item.id.toString(),
          }));
          setUserRolesList(formattedUsersList);
        }
      })
      .catch((e) => {});
  }, []);
  return (
    <SearchDropdown
      id={'user-role-dropdown'}
      selectedValue={selectedUserRole}
      options={userRolesList && userRolesList}
      onSelect={(item) => {
        setSelectedUserRole(item.value);
      }}
    />
  );
};

export default SelectUserRoleDropdown;
